<template>
    <div>
        <table v-if="!loading && services.length">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Nome</th>
                    <th>Ultima atualização</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ser, index) in services" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{ ser.name }}</td>
                    <td><i :class="ser.class"></i> ({{ ser.class }})</td>
                    <td>
                        <template v-if="ser.lastUpdate">{{ $moment(ser.lastUpdate,'X').format('DD/MM/YYYY HH:mm') }}</template>
                        <template v-else>{{ $moment(ser.createdAt,'X').format('DD/MM/YYYY HH:mm') }}</template>
                    </td>
                    <td><button @click="openForm(index)"><i class="mdi mdi-pencil"></i></button></td>
                </tr>
            </tbody>
        </table> 
        <p v-if="loading">Carregando...</p>
        <template v-if="!loading && !services.length">
            <strong>Nenhum registro</strong>
        </template>
        <button class="button" type="button" @click="edit = true">Adicionar</button>
        <modal :show="edit" v-model="edit">
            <div slot="body">
                <service :service="service" v-if="edit" :callback="close"></service>
            </div>
        </modal>

    </div>
</template>
<script>
import service from './Form.vue'
import Modal from '../../components/Modal'
export default {
    name: 'servicesList',
    components: {
        service,
        Modal
    },
    data(){
        return{
            loading: false,
            services: [],
            service: {},
            edit: false
        }
    },
    mounted(){
        this.loadService()
    },
    methods: {
        openForm(index){
            this.service = this.services[index]
            this.edit = true
        },
        close(){
            this.service = {}
            this.edit = false
            this.loadService()
        },
        loadService(){
            this.loading = true
            this.$db.collection("aplications").get().then((snap) => {
                let service = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    service.push(data)
                });

                this.services = service
                this.loading = false
            })
        }
    }
}
</script>  